import { takeLatest, put, all, call } from 'redux-saga/effects';
import MemberRejectionReportActionTypes from './member-rejection.report.types';
import {
	fetchMemberRejectionReport,
	exportMemberRejectionExcel,
	fetchMemberRejectionReasoncount,
} from './member-rejection-report.services';
import {
	fetchMemberRejectionReportSuccess,
	fetchMemberRejectionReportFailure,
	fetchMemberRejectionReportResponseChanged,
	exportMemberRejectionReportResponseChanged,
	exportMemberRejectionReportSuccess,
	exportMemberRejectionReportFailure,
	fetchMemberRejectionReasoncountSuccess,
	fetchMemberRejectionReasoncountFailure,
	fetchMemberRejectionReasoncountResponseChanged,
} from './member-rejection-report.action';
import { encryptData } from '../../_common/enode-decode';

import AlertManager from '../../../utils/alertManager';
/** *********************  START FETCH WALLET REPORT DETAILS ******************** */
export function* fetchMemberrejectionReportDetails({ payload }: any) {
	try {
		const key = 'MemberRejectionReportKey';
		const jsonData = {
			CompanyID: payload.companyID,
			LocationID: payload.centerID,
			Reason: payload.reason,
			DatabaseName: payload.databaseName,
			FromDate: payload.fromDate,
			ToDate: payload.toDate,
			Limit: payload.limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchMemberRejectionReport, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchMemberRejectionReportFailure(responseData.data));
		} else {
			yield put(fetchMemberRejectionReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchMemberRejectionReportFailure(error));
	}
}

export function* resetFetchMRRReportResponse() {
	yield put(fetchMemberRejectionReportResponseChanged());
}

export function* onFetchMemberRejectionReport() {
	yield takeLatest(
		MemberRejectionReportActionTypes.FETCH_MEMBER_REJECTION_REPORT_START,
		fetchMemberrejectionReportDetails,
	);
}

export function* onFetchMemberRejectionReportResponseReset() {
	yield takeLatest(
		MemberRejectionReportActionTypes.FETCH_MEMBER_REJECTION_REPORT_RESPONSE_RESET,
		resetFetchMRRReportResponse,
	);
}
/** ********************* END FETCH WALLET REPORT DETAILS ******************** */

/** *********************  START FETCH WALLET REPORT DETAILS ******************** */
export function* exportMemberrejectionReportDetails({ payload }: any) {
	try {
		const key = 'RejectionMembersExcelKey';
		const jsonData = {
			CompanyID: payload.companyID,
			LocationID: payload.centerID,
			Reason: payload.reason,
			DatabaseName: payload.databaseName,
			UserID: payload.userID,
			RequestID: payload.requestID,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(exportMemberRejectionExcel, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(exportMemberRejectionReportFailure(responseData.data));
		} else {
			yield put(exportMemberRejectionReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(exportMemberRejectionReportFailure(error));
	}
}

export function* resetExportMRRReportResponse() {
	yield put(exportMemberRejectionReportResponseChanged());
}

export function* onExportMemberRejectionReport() {
	yield takeLatest(
		MemberRejectionReportActionTypes.EXPORT_MEMBER_REJECTION_REPORT_START,
		exportMemberrejectionReportDetails,
	);
}

export function* onExportMemberRejectionReportResponseReset() {
	yield takeLatest(
		MemberRejectionReportActionTypes.EXPORT_MEMBER_REJECTION_REPORT_RESPONSE_RESET,
		resetExportMRRReportResponse,
	);
}
/** ********************* END FETCH WALLET REPORT DETAILS ******************** */

/** *********************  START FETCH REJECTION REASON COUNT DETAILS ******************** */
export function* fetchMemberrejectionReasoncountDetails({ payload }: any) {
	try {
		const key = 'MemberRejectionReasoncountKey';
		const jsonData = {
			CompanyID: payload.companyID,
			LocationID: payload.centerID,
			Reason: payload.reason,
			DatabaseName: payload.databaseName,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(fetchMemberRejectionReasoncount, encodeData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(fetchMemberRejectionReasoncountFailure(responseData.data));
		} else {
			yield put(fetchMemberRejectionReasoncountSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchMemberRejectionReasoncountFailure(error));
	}
}

export function* resetFetchMRRReasoncountResponse() {
	yield put(fetchMemberRejectionReasoncountResponseChanged());
}

export function* onFetchMemberRejectionReasoncount() {
	yield takeLatest(
		MemberRejectionReportActionTypes.FETCH_MEMBER_REJECTION_REASON_COUNT_START,
		fetchMemberrejectionReasoncountDetails,
	);
}

export function* fetchMemberRejectionReasoncountResponseReset() {
	yield takeLatest(
		MemberRejectionReportActionTypes.FETCH_MEMBER_REJECTION_REASON_COUNT_RESPONSE_RESET,
		resetFetchMRRReasoncountResponse,
	);
}
/** ********************* END FETCH REJECTION REASON COUNT DETAILS ******************** */

export function* memberRejectionReportSaga() {
	yield all([
		call(onFetchMemberRejectionReport),
		call(onFetchMemberRejectionReportResponseReset),
		call(onExportMemberRejectionReport),
		call(onExportMemberRejectionReportResponseReset),
		call(onFetchMemberRejectionReasoncount),
		call(fetchMemberRejectionReasoncountResponseReset),
	]);
}
